/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFDomainsDns
 */
export interface CRSFDomainsDns {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFDomainsDns
     */
    results: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainsDns
     */
    total: number;
}

/**
 * Check if a given object implements the CRSFDomainsDns interface.
 */
export function instanceOfCRSFDomainsDns(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFDomainsDnsFromJSON(json: any): CRSFDomainsDns {
    return CRSFDomainsDnsFromJSONTyped(json, false);
}

export function CRSFDomainsDnsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainsDns {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': json['results'],
        'total': json['total'],
    };
}

export function CRSFDomainsDnsToJSON(value?: CRSFDomainsDns | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results,
        'total': value.total,
    };
}

